export const queryKeys = {
  BOSS_PAYMENT_DELAY: 'BOSS_PAYMENT_DELAY',
  BOSS_PAYMENT_DELAY_EXCEL: 'BOSS_PAYMENT_DELAY_EXCEL'
};
